import React from 'react'
import classnames from 'classnames'

import Arrow from '@Images/sidebar_account_arrow.svg'

import './AccountButton.scss'

interface AccountButtonProps {
  readonly currentAccountId: number
  readonly currentAccountName: string
  readonly currentAccountAvatarUrl?: string
  readonly accountPopupIsOpen: boolean
  toggleAccountPopup(): void
}

const AccountButton: React.FC<AccountButtonProps> = props => {
  const {
    currentAccountId,
    currentAccountName,
    currentAccountAvatarUrl,
    accountPopupIsOpen
  } = props

  const lastDigitOfCurrentAccountId = currentAccountId % 10
  const isPlaceholder = !currentAccountAvatarUrl

  return (
    <div
      className={classnames(
        'AccountButton',
        'AccountPopup__element',
        { 'AccountButton__active': accountPopupIsOpen }
      )}
      onClick={props.toggleAccountPopup}
    >
      <div className="AccountButton__left">
        <div
          className={classnames(
            'AccountButton__avatar-base',
            isPlaceholder
              ? `AccountButton__avatar-placeholder AccountButton__avatar-placeholder-background-${lastDigitOfCurrentAccountId}`
              : 'AccountButton__avatar'
          )}
        >
          {isPlaceholder ? (
            <span className="AccountButton__avatar-initial">
              {currentAccountName.charAt(0)}
            </span>
          ) : (
            <img
              src={currentAccountAvatarUrl}
              alt="Account avatar"
              className="AccountButton__avatar-image"
            />
          )}
        </div>
        <div className="AccountButton__name">
          {currentAccountName}
        </div>
      </div>
      <Arrow className="AccountButton__arrow"/>
    </div>
  )
}

export default AccountButton
